import React from "react";
import { Link } from "react-router-dom";
import "./ServiceSection.css";
import "animate.css";

function ServicesSection() {
  const services = [
    {
      title: "Avanti School",
      description:
        "Ujjain/Avanti is the place where Lord Krishna got education with Balarama and Sudama from Maharishi Sandipani. At Avanti, they learnt 64 arts in 64 days.",
      link: "https://www.avantischools.com/",
    },
    {
      title: "Goshala",
      description:
        "We care for 450 cows daily in our goshala & now it's your turn to help us care for cows. We request you to join us for support and feed.",
      link: "/services/goshala",
    },
    {
      title: "Govinda’s Restaurant",
      description:
        "Experience the taste of pure vegetarian cuisine at ISKCON Govinda’s, offering a variety of delicious and sanctified food items.",
      link: "/services/govindas",
    },
    {
      title: "84 Mahadevs",
      description:
        "Shri Nandiswara, in the Shiva Purana, elucidates the twelve Jyotirlingas of Lord Shiva. Shri Mahakaleshwara Mahadeva, a prominent Jyotirlinga.",
      link: "/mahadev",
    },
    {
      title: "AIHE",
      description:
        "The AIHE aims to preserve and disseminate standards Srila Prabhupada set for acting in Krishna consciousness and to deepen devotee's understanding.",
      link: "https://aihe.iskconujjain.com/",
    },
    {
      title: "Guest House",
      description:
        "The guest house hosts both devotee and prospective devotee guests from around the globe. There are 22 luxurious marble rooms available.",
      link: "https://guesthouse.iskconujjain.com/",
    },
    {
      title: "ISKCON Altars",
      description:
        "When the ISKCON temple at Ujjain was inaugurated in 2006, we decided to buy three very large-sized altars for our temple deities.",
      link: "https://www.divinesky.net/",
    },
    {
      title: "Ayurvedic Clinic",
      description:
        "Ayurveda has reached great heights in India due to its natural surroundings, deep-rooted science of healing, and the hard work of dedicated practitioners.",
      link: "https://arogyaniketan.com/",
    },
    {
      title: "Deities Dress",
      description:
        "When we inaugurated our temple in Ujjain, we ordered 27 sets of dresses from Vrindavan, Mumbai, and Mayapur for our deities.",
      link: "/services/deities",
    },
    
  ];

  return (
    <section className="services">
      <div className="container">
        <h2 className="section-title">Our Services</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div
              key={index}
              className="service-card animate__animated animate__fadeInUp"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              {[
                "Avanti School",
                "AIHE",
                "Ayurvedic Clinic",
                "ISKCON Altars",
                "Guest House",
              ].includes(service.title) ? (
                <a
                  href={service.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="read-more-btn"
                >
                  Read More
                </a>
              ) : (
                <Link to={service.link} className="read-more-btn">
                  Read More
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
